import { PString } from "../properties/PString";
import { PAny } from "../properties/PAny";
import { PBoolean } from "../properties/PBoolean";
import { json } from "../../global";
import { PImage } from "../properties/PImage";
import { envMapLoader } from "./helper/envMapLoader";

import { AbstractMetaJsonNode } from "./AbstractMetaJsonNode";
import { Texture } from "three";

export class EnvMapJson extends AbstractMetaJsonNode {
  Type: string;
  RGBM: boolean;
  image_360: string;
  image_pos_x: string;
  image_neg_x: string;
  image_pos_y: string;
  image_neg_y: string;
  image_pos_z: string;
  image_neg_z: string;
  texture3d: Texture;

  get imageVersions() {
    return _.sumBy(
      this.getProperties()
        .filter((p) => p instanceof PImage)
        .map((p) => (p as PImage).version),
    );
  }

  init() {
    super.init();
    this.updateScene();
    return this;
  }

  get isEuirectangular() {
    return this.Type == "Equirectangular";
  }

  updateScene() {
    this._dataChanged = {};
    if (!(this.changed("json", () => this.toJSON()) || this.changed("imageVersions"))) {
      return;
    }
    const urls = this.isEuirectangular
      ? [this.image_360]
      : [
          this.image_pos_x,
          this.image_neg_x,
          this.image_pos_y,
          this.image_neg_y,
          this.image_pos_z,
          this.image_neg_z,
        ];
    const fullUrls = urls.map((x) => APP.sceneNode.getTextureUrl(x));
    this.texture3d = envMapLoader(fullUrls, APP.renderer, this.RGBM, () => {
      APP.sceneNode.callDebouncedUpdateSceneOn(APP.sceneNode.environmentJson);
    });
  }

  createProperties() {
    return [
      new PAny({
        name: "id",
        type: "Id",
        node: this,
        showInEditor: (p) => false,
      }),
      new PString({
        name: "name",
        primaryKey: true,
        comment: "Interner eindeutiger Primärschlüssel",
        node: this,
      }),
      new PString({
        name: "Type",
        selectOptions: ["Equirectangular", "Cube"],
        default: "Equirectangular",
        node: this,
      }),
      new PBoolean({
        name: "RGBM",
        default: false,
        defaultInJson: false,
        comment:
          "Falls es sich um ein PNG im RGBM Format handelt (ein spezielles HDR-Format), muss diese Checkbox gesetzt sein.",
        node: this,
      }),
      new PImage({
        name: "image_360",
        contentPath: "EnvMapJson/",
        comment:
          "Ein 360° Panorama-Foto (Equirectangular). Es werden die Bildformate jpg,png,exr,hdr unterstützt. Die Seitenlänge des Bildes muss eine Zweierpotenz sein.",
        defaultInJson: false,
        showInEditor: (p) => p.node.Type == "Equirectangular",
        node: this,
      }),
    ].concat(
      _.range(0, 6).map(
        (i) =>
          new PImage({
            name:
              "image_" + (i % 2 == 0 ? "pos" : "neg") + "_" + ["x", "y", "z"][Math.floor(i / 2)],
            contentPath: "EnvMapJson/",
            comment:
              "Textur für die Seite eines Würfels (SkyCube). Es werden die Bildformate jpg,png,exr,hdr unterstützt. Die Seitenlänge des Bildes muss eine Zweierpotenz sein.",
            defaultInJson: false,
            showInEditor: (p) => p.node.Type == "Cube",
            node: this,
          }),
      ),
    );
  }
}
